import { modifier } from 'ember-modifier';
import isScrolledToBottom from '@dashboard/shared-ui/utils/is-scrolled-to-bottom';

/**
 * Triggers a callback when the element has <= distanceFromBottom (default 1) scrollheight remaining (i.e.
 * cannot be scrolled any further).
 */
export default modifier(function onScrollToBottom(element, [callback, distanceFromBottom = 1]) {
  function onScroll() {
    if (isScrolledToBottom(element, {
      distanceFromBottom
    })) {
      callback();
    }
  }
  element.addEventListener('scroll', onScroll);
  return () => {
    element.removeEventListener('scroll', onScroll);
  };
});